import { render, staticRenderFns } from "./BeforeIndex.vue?vue&type=template&id=488e600b&scoped=true"
import script from "./BeforeIndex.vue?vue&type=script&lang=js"
export * from "./BeforeIndex.vue?vue&type=script&lang=js"
import style0 from "./BeforeIndex.vue?vue&type=style&index=0&id=488e600b&prod&scoped=scoped&lang=less"
import style1 from "./BeforeIndex.vue?vue&type=style&index=1&id=488e600b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e600b",
  null
  
)

export default component.exports